import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericItem } from '@shared/meta-data';
import {
  ARRAY_OF_CANADA_PROVINCES,
  ARRAY_OF_INTERNATIONAL_COUNTRIES,
} from '../address-list/address-list-form.interface';

@Component({
  selector: 'app-country-filter-dropdown',
  templateUrl: './country-filter-dropdown.component.html',
})
export class CountryFilterDropdownComponent implements OnInit {
  jurisdictions: GenericItem[] = [];

  @Input() placeholder = 'Filter by Country';
  @Input() notFoundText = 'No result found';
  @Input() color: 'primary' | 'success' | 'warning' = 'success';

  @Output() countryChange = new EventEmitter<string[]>();

  ngOnInit(): void {
    const canadaProvinces = ARRAY_OF_CANADA_PROVINCES.map((province) => ({
      id: `CA-${province.id}`,
      name: province.name,
    }));

    this.jurisdictions = [
      ...ARRAY_OF_INTERNATIONAL_COUNTRIES,
      ...canadaProvinces,
    ].sort((a, b) => a.name.localeCompare(b.name));
  }

  onCountryChange(selectedCountries: string[]): void {
    this.countryChange.emit(selectedCountries ?? []);
  }
}
